import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 0;\n  display: flex;\n  flex-shrink: 0;\n  height: 1px;\n  margin: ", ";\n  overflow: visible;\n  position: relative;\n  text-align: center;\n  width: 100%;\n\n  &::after {\n    background-color: ", ";\n    color: ", ";\n    content: attr(data-content);\n    display: ", ";\n    font-size: 16px;\n    font-weight: ", ";\n    line-height: 18px;\n    ", "\n\n    padding: 0 11px;\n    text-transform: uppercase;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { color, typography } from '@scp/ui-shared/theme/variables';
import { position } from 'polished';
var Line = styled.hr(_templateObject(), color.border, function (props) {
  return props.noMargin ? 0 : '24px 0';
}, color.palette.white, color.textPrimary, function (props) {
  return props['data-content'] ? 'inline-block' : 'none';
}, typography.fontWeightSemiBold, position('relative', '-9px', null, null, null));
/**
 * A Separator component. Use when you want to add a label that has a horizontal line beneath it.
 * Not including the label will just add a simple horizontal line.
 *
 * @example ./__docs__/Separator.md
 */

export var Separator = function Separator(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin;
  return React.createElement(Line, {
    "data-content": label,
    className: className,
    noMargin: noMargin
  });
};